export const CLIENT_ROUTE_DATA= {
    "ROUTES": [
        {
            "path": "corporate-banking",
            "data": {
                "tile": "corporate-banking",
                "pageId": "128b3035-5c49-4459-91a1-18d159b56e58",
                "appId": "d5da84c9-b6c7-4cd6-9743-a2064dce8b6a"
            }
        },
        {
            "path": "retail-banking",
            "data": {
                "tile": "retail-banking",
                "pageId": "128b3035-5c49-4459-91a1-18d159b56e58",
                "appId": "d5da84c9-b6c7-4cd6-9743-a2064dce8b6a"
            }
        },
        {
            "path": "banking",
            "data": {
                "tile": "banking",
                "pageId": "128b3035-5c49-4459-91a1-18d159b56e58",
                "appId": "d5da84c9-b6c7-4cd6-9743-a2064dce8b6a"
            }
        },
    ]
   };